import React, { useEffect, useState } from "react";
import { GLOBAL_IMAGES, HEADER } from "../../assets/asset";
import { colors } from "../../assets/components/ai/constants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AiParentsReport = () => {
  const { user } = useSelector((state) => state.user);
  const [metrics, setMetrics] = useState({
    accuracy: 0,
    Score: 0,
    totalMarks: 0,
    attempted: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}aiParentsReport`,
        {
          method: "POST",
          headers: {
            Authorization: `${process.env.REACT_APP_AUTH_TOKEN_DEV}`,
            "Content-Type": "application/json",
            jwt: token,
          },
          body: JSON.stringify({ yearstandardId: user?.school }),
        },
      );

      const data = await response.json();
      if (data.status_code === "200") {
        const res = data.data;
        setMetrics({
          accuracy: parseFloat(res.accuracy),
          Score: parseFloat(res.Score),
          totalMarks: parseFloat(res["total marks"]),
          attempted: parseFloat(res["attempted question"]),
        });
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  };

  const MetricBox = ({ title, value, maxValue, color }) => {
    const percentage = maxValue ? (value / maxValue) * 100 : value;
    const label = maxValue ? `${value}/${maxValue}` : `${value}%`;

    return (
      <div className="ai-report-metric bg-white rounded-xl p-4 mb-4">
        <div className="ai-report-metric-title font-semibold text-lg mb-2">
          {title}
        </div>
        <div className="ai-report-metric-user text-sm mb-1">
          {user?.user_name}'s
        </div>
        <div className="ai-report-progress w-full h-2 bg-gray-200 rounded-full mb-2">
          <div
            className="h-full rounded-full"
            style={{ width: `${percentage}%`, backgroundColor: color }}
          ></div>
        </div>
        <div className="ai-report-metric-value text-sm">{label}</div>
        <div className="ai-report-progress w-full h-2 bg-gray-200 rounded-full mt-1">
          <div
            className="h-full rounded-full bg-blue-600"
            style={{ width: `0%` }}
          ></div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="ai-report-page h-screen flex flex-col items-center font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.aiBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      role="main"
      aria-labelledby="AI-report-title"
    >
      <div
        className="ai-report-header h-[100px] justify-between flex items-center w-full px-4"
        style={{ background: "#36363699" }}
      >
        <img src={HEADER.AI} alt="AI" className="ai-report-logo w-20 h-15" />
        <h1 className="ai-report-title text-white font-bold text-2xl">
          Progress Report
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="ai-report-close text-white px-6 font-mali text-xl font-bold py-2 rounded-lg hover:bg-red-700"
          style={{ background: colors.linearGradient }}
        >
          Close
        </button>
      </div>

      <div className="ai-report-panel mt-6 w-[90%] max-w-3xl bg-gray-500/80 rounded-2xl p-6 text-black">
        <MetricBox
          title="Accuracy"
          value={metrics.accuracy * 100}
          color="lightgreen"
        />
        <MetricBox
          title="Score"
          value={metrics.Score}
          maxValue={metrics.totalMarks}
          color="#facc15"
        />
        <MetricBox
          title="Attempted Questions"
          value={metrics.attempted}
          color="#c084fc"
        />
      </div>
    </div>
  );
};

export default AiParentsReport;
